// @flow

import * as React from 'react';

import { CircleUserRound } from 'lucide-react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectIsAuthenticatedUser } from '@gandi/authentication';
import { withTranslator, type TranslatorProps } from '@gandi/translate';

import { Drawer, useDrawerState, DrawerContent } from '@gandi/ui';
import { SecondaryMenuButton } from '@gandi/ui/layout';

import { withBasename, type WithBasenameProps } from 'src/helpers/withBasename';
import { withRouter, type WithRouterProps } from 'src/helpers/withRouter';

import { selectUserItems } from 'src/modules/app';
import type { FullState } from 'src/types';

import type { NavigationItems } from '../../types';

import UserWidgetMobile from './UserWidgetMobile';

type InjectedProps = {
  translator: TranslatorProps,
  ...WithRouterProps<>,
  ...WithBasenameProps,
};

type StateProps = {
  isAuthenticated: boolean,
  items: NavigationItems,
};

export type Props = {
  ...InjectedProps,
  ...StateProps,
};

const mapStateToProps = (
  state: FullState,
  {
    translator: { __ },
    location: { pathname, search },
    basename,
  }: InjectedProps,
): StateProps => ({
  isAuthenticated: selectIsAuthenticatedUser(state),
  items: selectUserItems(state, { __, basename, pathname, search }),
});

function UserWidgetMobileWithDrawer({ translator }: Props): React.Node {
  const { __ } = translator;
  const buttonTitle = __(
    '<for-translators-use>Admin accessibility landmark</for-translators-use>User menu',
  );

  const drawer = useDrawerState();

  const openDrawer = () => {
    drawer.show();
  };

  return (
    <>
      <SecondaryMenuButton
        icon={<CircleUserRound size="20" />}
        onClick={openDrawer}
        title={buttonTitle}
      />

      <Drawer {...drawer} position="bottom" modal>
        <DrawerContent>
          <UserWidgetMobile />
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default (compose(
  withRouter,
  withBasename,
  withTranslator({ propsNamespace: 'translator' }),
  connect(mapStateToProps),
)(UserWidgetMobileWithDrawer): React.ComponentType<{}>);
